export default "__VITE_ASSET__29c23e22__"